__turbopack_context__.v({
  "equalGap": "Grid-module-scss-module__0JmOaG__equalGap",
  "fade-in": "Grid-module-scss-module__0JmOaG__fade-in",
  "grid": "Grid-module-scss-module__0JmOaG__grid",
  "no-transform": "Grid-module-scss-module__0JmOaG__no-transform",
  "rotate": "Grid-module-scss-module__0JmOaG__rotate",
});
